import { render, staticRenderFns } from "./EditCustomerModal.vue?vue&type=template&id=446d3925&scoped=true"
import script from "./EditCustomerModal.vue?vue&type=script&lang=ts"
export * from "./EditCustomerModal.vue?vue&type=script&lang=ts"
import style0 from "./EditCustomerModal.vue?vue&type=style&index=0&id=446d3925&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446d3925",
  null
  
)

export default component.exports